import { resetRouter } from '@/router'

export function resetTokenAndClearUser() {
    // 退出登陆 清除用户资料
    localStorage.clear()
    sessionStorage.clear()
    // 重设路由
    resetRouter()
}

export const defaultDocumentTitle = '绿居物业管理后台'
export function getDocumentTitle(pageTitle) {
    if (pageTitle) return `${defaultDocumentTitle} - ${pageTitle}`
    return `${defaultDocumentTitle}`
}